module.exports = __webpack_public_path__ + "img/EHB-info.ff87e80e.png";